import { render, staticRenderFns } from "./PasswordSettingForm.vue?vue&type=template&id=33644eac&scoped=true"
import script from "./PasswordSettingForm.vue?vue&type=script&lang=ts"
export * from "./PasswordSettingForm.vue?vue&type=script&lang=ts"
import style0 from "./PasswordSettingForm.vue?vue&type=style&index=0&id=33644eac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33644eac",
  null
  
)

export default component.exports